import { Directive, Inject, Injector, OnInit } from '@angular/core';
import { UserSettings, UserSettingsToken } from '@farris/devkit';
import { TimePickerComponent } from '@farris/ui-time-picker';

@Directive({
  selector: '[farris-time-localization]'
})
export class FarrisTimeLocalizationDirective implements OnInit {
  constructor(private injector: Injector, @Inject(UserSettingsToken) private userSettings: UserSettings, private componentRef: TimePickerComponent) {

  }
  ngOnInit(): void {
    this.localize();
  }
  private localize() {
    if (this.userSettings && this.componentRef) {
      const { timeFormat = null } = this.userSettings;
      if (timeFormat) {
        this.componentRef.format = timeFormat;
      }
    }
  }
}
